import { extractYear } from '../../utils/extractYear';

export const formationColumns = [
  {
    key: 'title',
    label: 'Titre',
    render: (row) => row.title?.fr || row.title?.en,
    sortable: true,
    sortValue: (row) => row.title?.fr || row.title?.en || ''
  },
  {
    key: 'date',
    label: 'Date',
    render: (row) => row.date?.fr,
    sortable: true,
    sortValue: (row) => extractYear(row.date?.fr)
  }
];

export const formationFields = [
  { name: 'logo', label: 'Logo', type: 'asset' },
  { name: 'date', label: 'Date', type: 'bilingual' },
  { name: 'title', label: 'Titre', type: 'bilingual', required: true },
  { name: 'description', label: 'Description', type: 'bilingual', as: 'textarea' }
];
